export const actionTypes = {
  SET_OaRVaR: "SET_OaRVaR",
  SET_OaR_FILTERED: "SET_OaR_FILTERED",
  SET_VaR_FILTERED: "SET_VaR_FILTERED",
  SET_FILTER: "SET_FILTER",
  SET_FILTER_DEFAULTS: "SET_FILTER_DEFAULTS",
  SET_LOADING: "SET_LOADING",
};
